export enum EmopTableProHeaderSortOrderEnum {
  ascend = 'ascend',
  descend = 'descend',
  null = 'null'
}